var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M15.4044 3.29413L12.6643 0.544205C12.3067 0.207084 11.8381 0.0136488 11.3477 0.000695267C10.8572 -0.0122583 10.3791 0.156174 10.0043 0.473951L1.00421 9.50655C0.680976 9.8337 0.479713 10.2625 0.434208 10.7209L0.004203 14.906C-0.00926819 15.053 0.00973739 15.2012 0.0598648 15.34C0.109992 15.4788 0.190007 15.6047 0.294206 15.7089C0.387647 15.802 0.498465 15.8755 0.620304 15.9255C0.742142 15.9754 0.872606 16.0007 1.00421 16H1.09422L5.26426 15.6186C5.72106 15.5729 6.14831 15.3709 6.47428 15.0465L15.4744 6.01395C15.8237 5.64358 16.0125 5.14933 15.9994 4.63952C15.9862 4.12971 15.7723 3.64591 15.4044 3.29413ZM5.08426 13.6114L2.08423 13.8924L2.35423 10.8815L8.00429 5.2813L10.7043 7.99108L5.08426 13.6114ZM12.0043 6.64623L9.32431 3.95652L11.2743 1.94928L14.0044 4.68916L12.0043 6.64623Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f661bedb3ad4f62ddc7d593a0b2134c.svg";
export { ForwardRef as ReactComponent };